"use strict";

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _commonReact = require("@devsta/common-react");

var _reactApollo = require("react-apollo");

var _ShareModal = _interopRequireDefault(require("../components/ShareModal"));

var _api = require("../api");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function getRelevantOrgFromMemberships(memberships, organisationId) {
  var membership = memberships.find(function (_ref) {
    var organisation = _ref.organisation;
    return organisation.organisationId === organisationId;
  });
  return membership && membership.organisation;
}

function ShareModal(_ref2) {
  var outputId = _ref2.outputId,
      props = _objectWithoutProperties(_ref2, ["outputId"]);

  return (/*#__PURE__*/_react.default.createElement(_commonReact.RequestProvider, {
      requests: {
        shareVideo: (0, _api.shareVideoQuery)(outputId),
        getShareAccounts: (0, _api.getShareAccountsQuery)(),
        getUserTeams: (0, _api.getUserTeamsQuery)()
      }
    }, function (_ref3) {
      var shareVideo = _ref3.shareVideo,
          getShareAccounts = _ref3.getShareAccounts,
          getUserTeams = _ref3.getUserTeams;
      return (/*#__PURE__*/_react.default.createElement(_commonReact.AuthorisationConsumer, null, function (_ref4) {
          var organisationMemberships = _ref4.organisationMemberships;
          return (/*#__PURE__*/_react.default.createElement(_reactApollo.ApolloConsumer, null, function (apiClient) {
              var organisation = getRelevantOrgFromMemberships(organisationMemberships, props.organisationId);

              if (!organisation) {
                return null;
              }

              return (/*#__PURE__*/_react.default.createElement(_ShareModal.default, _extends({
                  outputId: outputId,
                  shareVideo: shareVideo,
                  getShareAccounts: getShareAccounts,
                  getUserTeams: getUserTeams,
                  apiClient: apiClient,
                  organisation: organisation
                }, props))
              );
            })
          );
        })
      );
    })
  );
}

var _default = (0, _react.memo)(ShareModal);

exports.default = _default;